/***
*
*   ACCOUNT NAV
*   Acount sub nav that renders different options based
*   on user permissions. Shows billing & user admin to only account owners
*
**********/

import React, { useContext } from 'react';
import { NavLink, useParams } from "react-router-dom";
import { AuthContext } from 'components/lib';
import 'components/nav.scss';

export default function AccountNav(props){

  const context = useContext(AuthContext);
  const { id: accountId } = useParams();
  const isHealthScoreOnly = context.user?.account_type === 'health_score_only';

  return(
    <nav className='subnav'>

      <NavLink exact to={`/account/${accountId}`} activeClassName='active'>Account</NavLink>
      <NavLink exact to={`/account/${accountId}/emails`} activeClassName='active'>E-mail Digest</NavLink>
      {isHealthScoreOnly ? (
        <span className='disabled'>API Keys</span>
      ) : (
        <NavLink exact to={`/account/${accountId}/apikeys`} activeClassName='active'>API Keys</NavLink>
      )}

    
    </nav>
  );
}
